module.exports = __webpack_public_path__ + "static/media/netflix-vox.2466c106.png";